import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=4118a87f&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4118a87f')) {
      api.createRecord('4118a87f', component.options)
    } else {
      api.reload('4118a87f', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=4118a87f&", function () {
      api.rerender('4118a87f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Si36eypDqa1c/JS/comp/starrating.vue"
export default component.exports